<template>
  <div
    class="flex justify-between bg-gray-3 rounded-[5px] h-12 items-center py-2.5 px-5"
  >
    <div v-if="title.length" class="text-primary-1 text-paragraph-1">{{ title }}</div>
    <label class="switch">
      <input
        type="checkbox"
        :name="name"
        v-model="booleanValue"
        @change="updateBooleanValue"
      />
      <span class="slider rounded-full"></span>
    </label>
  </div>
</template>
<script setup lang="ts">
import { ref, watch } from "vue";
const props = defineProps({
  title: {
    type: String,
    default: null,
  },
  value: {
    type: [String, Number, Boolean, Date],
    default: "",
  },
  defaultAnswer: {
    type: [String, Number, Boolean, Date],
    default: null,
  },
  name: {
    type: String,
    default: "",
  },
});
const booleanValue = ref<boolean>();
const emit = defineEmits(["boolean-changed"]);
watch(
  booleanValue,
  (newVal) => {
    updateBooleanValue();
  },
  { immediate: true }
);
watch(
  () => props.defaultAnswer,
  (newVal) => {
    booleanValue.value = Boolean(props.defaultAnswer);
    updateBooleanValue();
  },
  { immediate: true }
);
function updateBooleanValue() {
  let tmp = "false";
  if (booleanValue.value) {
    tmp = "true";
  }
  emit("boolean-changed", tmp);
}
</script>
